import React, { memo } from 'react';
import ProductTile from '../productTile';
import { theme } from './_vars';
import { formattedImagesArray, formatVariants, getProductDetails, getTags } from '@srcDS/utils/helpers';

const ProductResultsTile = ({ product, loggedIn, customerGroupId, nostoRecordSearchClick }) => {
  const {
    initialVariant,
    regularPrice,
    discountedPrice,
    onSale,
    currentDiscount: promoContent,
    finalSale,
  } = getProductDetails(product, true, loggedIn, customerGroupId);

  return (
    <ProductTile
      isSearchPage
      parentProduct={product}
      data-id={product.productId}
      data-sku={initialVariant.sku}
      productId={product.productId}
      remoteImage={false}
      productName={product?.name}
      position={product['__position']}
      images={formattedImagesArray(initialVariant)}
      regularPrice={regularPrice}
      onSale={onSale}
      discountedPrice={discountedPrice}
      inOnStock={initialVariant.inOnStock}
      promoContent={promoContent}
      currency={initialVariant.currency}
      url={`/clothing/${product.slug}` ?? product._url}
      variants={formatVariants(product.variants?.[0].attributes.variants)}
      item={initialVariant}
      tags={getTags(initialVariant, product, true, false)}
      placement={'Listing Page | Search'}
      productType={product.type || product.slug}
      label={initialVariant?.attributes?.newarrival ? 'New' : ''}
      theme={theme}
      gridType="wide"
      enableGallery={true}
      enableTouchOnMobile={true}
      finalSale={finalSale}
      nostoRecordSearchClick={nostoRecordSearchClick}
      type="autocomplete"
    />
  );
};
export default memo(ProductResultsTile);
